__webpack_require__.p = "https://fenwan.cdn.bcebos.com/gamecenter/static/game/";